import { useCallback } from 'react'
import dagre from 'dagre'
import { Node, Edge } from '@xyflow/react'
import { WORKFLOW } from '../tokens'

export const useAutoLayout = (
  nodes: Node[],
  edges: Edge[],
  setNodes: (updater: (nodes: Node[]) => Node[]) => void,
) => {
  const autoLayout = useCallback(() => {
    if (nodes.length === 0) return

    const g = new dagre.graphlib.Graph()
    g.setDefaultEdgeLabel(() => ({}))
    g.setGraph({ rankdir: 'TB', nodesep: 60, ranksep: 80 })

    nodes.forEach((node) => {
      g.setNode(node.id, { width: WORKFLOW.node.width, height: WORKFLOW.node.minHeight })
    })

    edges.forEach((edge) => {
      g.setEdge(edge.source, edge.target)
    })

    dagre.layout(g)

    setNodes((nds) =>
      nds.map((node) => {
        const pos = g.node(node.id)
        return {
          ...node,
          position: {
            x: pos.x - WORKFLOW.node.width / 2,
            y: pos.y - WORKFLOW.node.minHeight / 2,
          },
        }
      }),
    )
  }, [nodes, edges, setNodes])

  return autoLayout
}
